import React, { useState, useEffect } from "react";
import { DialogActions, DialogContent, FormControl, Button, Dialog, DialogTitle, MenuItem, Select } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";

export default function AssignTable({
  action,
  variables,
  setOpen,
  setOpenVariable,
  setDictionaryTable,
  dictionaryTable,
  index,
  setIndex,
}) {

  const [type, setType] = useState(
    index === -1 ? "" : action.fields.sourceVariable.value[index].type
  );

  // control of fields or set field
  useEffect(() => {
    if (index !== -1) {
      action.fields.keyVariable.value =
        action.fields.sourceVariable.value[index].key;
      action.fields.keyVariable.htmlValue =
        action.fields.sourceVariable.value[index].key;

      action.fields.valueVariable.value =
        action.fields.sourceVariable.value[index].value;
      action.fields.valueVariable.htmlValue =
        action.fields.sourceVariable.value[index].value;
    } else {
      if (action.fields.keyVariable) {
        action.fields.keyVariable = { value: "", htmlValue: "" };
        action.fields.valueVariable = { value: "", htmlValue: "" };
      }
    }
  }, [index]);

  // delete item in array
  function handleDelete() {
    dictionaryTable.splice(index, 1);
    setDictionaryTable(dictionaryTable);
    setOpen(false);
    setIndex(-1);
  }

  //update item in array
  function handleUpdate() {
    dictionaryTable[index].key = action.fields.keyVariable.value;
    dictionaryTable[index].type = type;
    dictionaryTable[index].value = action.fields.valueVariable.value;
    setOpen(false);
    setIndex(-1);
  }
  // added variable in array
  function handleAdd() {
    if (action.fields.keyVariable?.value && type.length > 0) {
      setDictionaryTable((oldArr) => [
        ...oldArr,
        {
          type,
          key: action.fields.keyVariable?.value,
          value: action.fields.valueVariable?.value,
        },
      ]);
      setOpen(false);
      setIndex(-1);
    }
  }

  // select type
  function handleChangeType(event) {
    setType(event.target.value);
  }

  // close modal
  function handleClose() {
    setOpen(false);
    setIndex(-1);
  }
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle id="alert-dialog-title">
        <Button
          style={{ float: "right" }}
          data-test="cancelautom-button"
          onClick={handleClose}
        >
          <Close />
        </Button>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "400px" }}>
          <div className="form-element">
            Type
            <FormControl variant="outlined" fullWidth>
              <Select value={type} onChange={handleChangeType} style={{ width: "90%" }}>
                <MenuItem value="string">String</MenuItem>
                <MenuItem value="number">Number</MenuItem>
                <MenuItem value="datetime">Datetime</MenuItem>
                <MenuItem value="boolean">Boolean</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="form-element">
            Key
            <TextInput
              action={action}
              inputName="keyVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
          <div className="form-element">
            Value
            <TextInput
              action={action}
              inputName="valueVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: index === -1 ? "flex-end" : "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        {index === -1 ? (
          <Button variant="outlined"
            style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
            onClick={handleAdd}>
            Add
          </Button>
        ) : (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleUpdate}>
              Edit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
